import BigNumber from "bignumber.js";

export const toOrdinal = (value: unknown): any => {
  const numberValue = Number(value);

  if (isNaN(numberValue) || numberValue === 0) {
    return value;
  }

  const flooredNumber = Math.floor(numberValue);
  if (flooredNumber === 0) {
    return "0";
  } else if (flooredNumber < 0) {
    return flooredNumber;
  }
  const lastDigit = flooredNumber % 10;
  const secondLastDigit = Math.floor((flooredNumber % 100) / 10);

  if (secondLastDigit === 1) {
    return flooredNumber + "th"; // Numbers ending in 11, 12, 13 are exceptions
  }

  switch (lastDigit) {
    case 1:
      return flooredNumber + "st";
    case 2:
      return flooredNumber + "nd";
    case 3:
      return flooredNumber + "rd";
    default:
      return flooredNumber + "th";
  }
};

export const truncateDecimals = (value: number, decimals: number) => {
  return new BigNumber(value).dp(decimals, BigNumber.ROUND_DOWN).toNumber();
};

// Combinations, "total choose chosen": how many distinct unordered groups of
// `chosen` items can be drawn from `total`. Used to count the legs a combo/multi
// bet expands into. Builds the result one factor at a time instead of dividing
// factorials so the running value stays small and never overflows.
export const nCr = (total: number, chosen: number): number => {
  if (chosen > total || chosen < 0) return 0;
  if (chosen === 0 || chosen === total) return 1;
  // C(total, chosen) equals C(total, total - chosen), so iterate over whichever
  // is smaller to do the fewest multiplications.
  const iterations = Math.min(chosen, total - chosen);
  let combinations = 1;
  for (let step = 0; step < iterations; step++) {
    combinations = (combinations * (total - step)) / (step + 1);
  }
  return Math.round(combinations);
};
